import type { FC } from "react"
import { Flex, Text } from "@chakra-ui/react"

import MarkdownViewer from "common/components/MarkdownViewer"
import CardContainer from "common/components/CardContainer"

const SummaryDescription: FC<{
  description: string
}> = ({ description }) => {
  return (
    <CardContainer
      isTableView
      pb={0}
      title="Details"
      width={{ base: "100%", sm: "750px" }}
    >
      <Flex
        pb={{ base: 1, sm: 2 }}
        pt={{ base: 2, sm: 2 }}
        px={{ base: 3, sm: 4 }}
      >
        {description ? (
          <MarkdownViewer content={description} />
        ) : (
          <Text color="gray.500" pb={{ base: 1, sm: 2 }}>
            Description empty
          </Text>
        )}
      </Flex>
    </CardContainer>
  )
}

export default SummaryDescription
